<template>
  <form @submit.prevent="submitForm">
    <!-- Die Kosten der Maßnahme -->
    <div class="row">
      <h6 class="mb-2 text-uppercase pl-3">
        1. Angaben zur Vorgeschichte
      </h6>
    </div>

    <div class="row ml-3">
      <div class="col-lg-6 col-md-6 col-sm-12 remove-form-group-bottom-margin">
        Wurden Sie bereits in einem Gesundheitsamt untersucht?
      </div>
      <div class="col-lg-1 col-md-2 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox
            v-model="formData.alreadyBeenExaminedYes"
            label="Ja"
            label-position="right"
        />
      </div>
      <div class="col-lg-1 col-md-2 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox
            v-model="formData.alreadyBeenExaminedNo"
            label="Nein"
            label-position="right"
        />
      </div>
    </div>

    <div class="row ml-3">
      <div class="col-lg-6 col-md-12 col-sm-12 remove-form-group-bottom-margin">
        <BaseInput
            v-model="formData.alreadyBeenExaminedWhen"
            label="Wann?"
            placeholder="Datum oder Zeitraum"
        />
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 remove-form-group-bottom-margin">
        <BaseInput
            v-model="formData.alreadyBeenExaminedWhere"
            label="Wo?"
            placeholder="Ort"
        />
      </div>
      <div class="col-sm-12 remove-form-group-bottom-margin">
        <BaseInput
            v-model="formData.reasonForExamination"
            label="Grund der Untersuchung"
            placeholder="Bitte angeben..."
        />
      </div>
    </div>

    <!-- 2. folgende Krankheiten/Krankheiten folgender Organe/Behinderungen lagen vor/liegen vor -->
    <div class="row mt-5">
      <h6 class="mb-2 text-uppercase pl-3">
        2. folgende Krankheiten/Krankheiten folgender Organe/Behinderungen lagen vor/liegen vor
      </h6>
    </div>

    <div class="row ml-3 mt-3">
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.heartDisease" label="Herzerkrankung" labelPosition="right" />
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.highLowBlowPressure" label="Hoher/Niedriger Blutdruck" labelPosition="right" />
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.bronchi" label="Bronchien" labelPosition="right" />
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.asthma" label="Asthma" labelPosition="right" />
      </div>
    </div>

    <div class="row ml-3 mt-3">
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.allergies" label="Allergien" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.tonsillitis" label="Mandelentzündung" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.diphtheria" label="Diphtherie" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.skin" label="Haut" labelPosition="right"/>
      </div>
    </div>

    <div class="row ml-3 mt-3">
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.rheumatism" label="Rheuma" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.thyroid" label="Schilddrüse" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.gallbladder" label="Gallenblase" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.liver" label="Leber" labelPosition="right"/>
      </div>
    </div>

    <div class="row ml-3 mt-3">
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.stomachAndIntestines" label="Magen & Darm" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.boneAndJointSystem" label="Knochen- & Gelenksystem" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.jaundice" label="Gelbsucht" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.kidneys" label="Nieren" labelPosition="right"/>
      </div>
    </div>

    <div class="row ml-3 mt-3">
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.diabetes" label="Diabetes" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.concussion" label="Gehirnerschütterung" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.sexuallyTransmittedDisease" label="Geschlechtskrankheit" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.gout" label="Gicht" labelPosition="right"/>
      </div>
    </div>

    <div class="row ml-3 mt-3">
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.mentalIllness" label="Psychische Krankheit" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.neurologicalDiseases" label="Neurologische Erkrankungen" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.varicoseVeins" label="Krampfadern" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.noDiseases" label="Keine Erkrankungen" labelPosition="right"/>
      </div>
    </div>

    <div class="row mt-5">
      <h6 class="mb-2 text-uppercase pl-3">3. Jetzige Beschwerden oder Krankheiten</h6>
    </div>

    <div class="row ml-3 mt-3">
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.visualImpairment" label="Sehstörung" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.eyeProblems" label="Augen-beschwerden" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.headache" label="Kopf-schmerzen" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.dizziness" label="Schwindel" labelPosition="right"/>
      </div>
    </div>

    <div class="row ml-3 mt-3">
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.sleepDisorders" label="Sleep Disorders" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.earNoseEars" label="Hals/Nase/Ohren" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.pains" label="Schmerzen" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.seizures" label="Anfälle" labelPosition="right"/>
      </div>
    </div>

    <div class="row ml-3 mt-3">
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.lossOfAppetite" label="Appetitlosigkeit" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.weightLoss" label="Gewichtsabnahme" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.nightSweats" label="Nacht-schweiß" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.cough" label="Husten" labelPosition="right"/>
      </div>
    </div>

    <div class="row ml-3 mt-3">
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.digestiveComplaints" label="Verdauungs-beschwerden" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.painfulUrination" label="Schmerzhaftes Wasserlassen" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.rheumatism2" label="Rheuma" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.heartProblems" label="Herz-beschwerden" labelPosition="right"/>
      </div>
    </div>

    <div class="row ml-3 mt-3">
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.backPain" label="Rückenschmerzen" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.moodAndDriveFluctuations" label="Stimmungs- und Antriebs-schwankung"
                      labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.nervousComplaints" label="Nervöse Beschwerden" labelPosition="right"/>
      </div>
    </div>

    <div class="row ml-3 mt-5">
      <div class="col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin">
        4. Haben Sie eine Rente beantragt?
      </div>
      <div class="col-lg-1 col-md-3 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.appliedForAPensionNo" label="Nein" labelPosition="right"/>
      </div>
      <div class="col-lg-1 col-md-3 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.appliedForAPensionYes" label="Ja" labelPosition="right"/>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 remove-form-group-bottom-margin">
        <BaseInput v-model="formData.appliedForAPensionReason" label="Grund"/>
      </div>
      <div class="col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseInput v-model="formData.appliedForAPensionPercentage" label="MdE %:"/>
      </div>
    </div>

    <div class="row ml-3 mt-4">
      <div class="col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin">
        5. Sind Sie schwerbehindert?
      </div>
      <div class="col-lg-1 col-md-3 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.severelyDisabledNo" label="Nein" labelPosition="right"/>
      </div>
      <div class="col-lg-1 col-md-3 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.severelyDisabledYes" label="Ja" labelPosition="right"/>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 remove-form-group-bottom-margin">
        <BaseInput v-model="formData.severelyDisabledReason" label="Grund"/>
      </div>
      <div class="col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseInput v-model="formData.severelyDisabledPercentage" label="GdB %:"/>
      </div>
    </div>

    <!-- 6. Sind Sie zurzeit in Behandlung? -->
    <div class="row ml-3 mt-4">
      <div class="col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin">
        6. Sind Sie zurzeit in Behandlung?
      </div>
      <div class="col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.undergoingTreatmentNo" label="Nein" labelPosition="right"/>
      </div>
      <div class="col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.undergoingTreatmentYes" label="Ja" labelPosition="right"/>
      </div>
      <div class="col-lg-7 col-md-12 col-sm-12 remove-form-group-bottom-margin">
        <BaseInput v-model="formData.undergoingTreatmentReason" label="Grund"/>
      </div>
    </div>

    <!-- 7. Nehmen Sie zurzeit Medikamente ein? -->
    <div class="row ml-3 mt-4">
      <div class="col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin">
        7. Nehmen Sie zurzeit Medikamente ein?
      </div>
      <div class="col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.takingMedicationNo" label="Nein" labelPosition="right"/>
      </div>
      <div class="col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.takingMedicationYes" label="Ja" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin">
        <BaseInput v-model="formData.takingMedicationWhich" label="Welche?"/>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12 remove-form-group-bottom-margin">
        <BaseInput v-model="formData.takingMedicationSince" label="Seit wann?"/>
      </div>
    </div>

    <!-- 8. Fühlen Sie sich gesund und leistungsfähig? -->
    <div class="row ml-3 mt-4">
      <div class="col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin">
        8. Fühlen Sie sich gesund und leistungsfähig?
      </div>
      <div class="col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.feelHealthyAnProductiveNo" label="Nein" labelPosition="right"/>
      </div>
      <div class="col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.feelHealthyAnProductiveYes" label="Ja" labelPosition="right"/>
      </div>
    </div>

    <!-- 9. Betätigen Sie sich sportlich? -->
    <div class="row ml-3 mt-4">
      <div class="col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin">
        9. Betätigen Sie sich sportlich?
      </div>
      <div class="col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.doAnySportsNo" label="Nein" labelPosition="right"/>
      </div>
      <div class="col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.doAnySportsYes" label="Ja" labelPosition="right"/>
      </div>
    </div>

    <!-- 10. Tragen Sie eine Sehhilfe? -->
    <div class="row ml-3 mt-4">
      <div class="col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin">
        10. Tragen Sie eine Sehhilfe?
      </div>
      <div class="col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.wearVisualAidsNo" label="Nein" labelPosition="right"/>
      </div>
      <div class="col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.wearVisualAidsYes" label="Ja" labelPosition="right"/>
      </div>
      <div class="col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.wearGlasses" label="Brille" labelPosition="right"/>
      </div>
      <div class="col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.wearContactLenses" label="Kontaktlinsen" labelPosition="right"/>
      </div>
    </div>

    <!-- 11. Rauchen Sie? -->
    <div class="row ml-3 mt-4">
      <div class="col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin">
        11. Rauchen Sie?
      </div>
      <div class="col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.smokeNo" label="Nein" labelPosition="right"/>
      </div>
      <div class="col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.smokeYes" label="Ja" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin">
        <BaseInput v-model="formData.smokeSince" label="Seit:"/>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12 remove-form-group-bottom-margin">
        <BaseInput v-model="formData.smokeDailyAmount" label="Tägliche Menge:"/>
      </div>
    </div>

    <!-- 12. Nehmen Sie regelmäßig alkoholische Getränke? -->
    <div class="row ml-3 mt-4">
      <div class="col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin">
        12. Nehmen Sie regelmäßig alkoholische Getränke (auch Bier) zu sich?
      </div>
      <div class="col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.drinkAlcoholicBeveragesNo" label="Nein" labelPosition="right"/>
      </div>
      <div class="col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.drinkAlcoholicBeveragesYes" label="Ja" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin">
        <BaseInput v-model="formData.drinkAlcoholicBeveragesSince" label="Seit:"/>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12 remove-form-group-bottom-margin">
        <BaseInput v-model="formData.drinkAlcoholicBeveragesAmount" label="Tägliche Menge:"/>
      </div>
    </div>

    <!-- 13. Haben Sie im letzten Jahr nicht verordnete Medikamente oder Drogen eingenommen? -->
    <div class="row ml-3 mt-4">
      <div class="col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin">
        13. Haben Sie im letzten Jahr nicht verordnete Medikamente oder Drogen eingenommen?
      </div>
      <div class="col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.anyMedicationOrDrugsInLastYearNo" label="Nein" labelPosition="right"/>
      </div>
      <div class="col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.anyMedicationOrDrugsInLastYearYes" label="Ja" labelPosition="right"/>
      </div>
      <div class="col-lg-7 col-md-6 col-sm-12 remove-form-group-bottom-margin">
        <BaseInput v-model="formData.anyMedicationOrDrugsInLastYearSince" label="Seit:"/>
      </div>
    </div>

    <!-- 14. Wurden Sie schonmal auf Ihre gesundheitliche Eignung untersucht? -->
    <div class="row ml-3 mt-4 mb-5">
      <div class="col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin">
        14. Wurden Sie schonmal auf Ihre gesundheitliche Eignung untersucht? (z.B. Musterung)
      </div>
      <div class="col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.examinedForHealthNo" label="Nein" labelPosition="right"/>
      </div>
      <div class="col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin">
        <BaseCheckbox v-model="formData.examinedForHealthYes" label="Ja" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin">
        <BaseInput v-model="formData.examinedForHealthWhere" label="Wo:"/>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12 remove-form-group-bottom-margin">
        <BaseInput v-model="formData.examinedForHealthResult" label="Ergebnis:"/>
      </div>
    </div>

    <div class="row mt-5 text-center">
      <div class="col-12">
        <SaveButton
            :label="$t('general.button.save')"
            :loading="isSubmitting"/>
      </div>
    </div>
  </form>
</template>

<script setup lang="ts">
import { defineEmits, defineProps, onMounted, ref, toRefs } from 'vue';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import unemployedPrivateCoachingService from '@/api/Unemployed/PrivateCoaching/index';
import { ErrorToast, SuccessToast } from '@/components/VueToast';
import { useI18n } from 'vue-i18n';
import SaveButton from '@/components/button/SaveButton.vue';

const props = defineProps({
  documentId: {
    type: String,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const documentId = toRefs(props)['documentId'];
const { t } = useI18n();
const isSubmitting = ref(false);
const emit = defineEmits(['update:submitForm']);

const formData = ref<any>({
  alreadyBeenExaminedYes: false,
  alreadyBeenExaminedNo: false,
  alreadyBeenExaminedWhen: "",
  alreadyBeenExaminedWhere: "",
  reasonForExamination: "",
  heartDisease: false,
  highLowBlowPressure: false,
  bronchi: false,
  asthma: false,
  allergies: false,
  tonsillitis: false,
  diphtheria: false,
  skin: false,
  rheumatism: false,
  thyroid: false,
  gallbladder: false,
  liver: false,
  stomachAndIntestines: false,
  boneAndJointSystem: false,
  jaundice: false,
  kidneys: false,
  diabetes: false,
  concussion: false,
  sexuallyTransmittedDisease: false,
  gout: false,
  mentalIllness: false,
  neurologicalDiseases: false,
  varicoseVeins: false,
  noDiseases: false,
  visualImpairment: false,
  eyeProblems: false,
  headache: false,
  dizziness: false,
  sleepDisorders: false,
  earNoseEars: false,
  pains: false,
  seizures: false,
  lossOfAppetite: false,
  weightLoss: false,
  nightSweats: false,
  cough: false,
  digestiveComplaints: false,
  painfulUrination: false,
  rheumatism2: false,
  heartProblems: false,
  backPain: false,
  moodAndDriveFluctuations: false,
  nervousComplaints: false,
  appliedForAPensionNo: false,
  appliedForAPensionYes: false,
  appliedForAPensionReason: '',
  appliedForAPensionPercentage: '',
  severelyDisabledNo: false,
  severelyDisabledYes: false,
  severelyDisabledReason: '',
  severelyDisabledPercentage: '',
  undergoingTreatmentNo: false,
  undergoingTreatmentYes: false,
  undergoingTreatmentReason: '',
  takingMedicationNo: false,
  takingMedicationYes: false,
  takingMedicationWhich: '',
  takingMedicationSince: '',
  feelHealthyAnProductiveNo: false,
  feelHealthyAnProductiveYes: false,
  doAnySportsNo: false,
  doAnySportsYes: false,
  wearVisualAidsNo: false,
  wearVisualAidsYes: false,
  wearGlasses: false,
  wearContactLenses: false,
  smokeNo: false,
  smokeYes: false,
  smokeSince: '',
  smokeDailyAmount: '',
  drinkAlcoholicBeveragesNo: false,
  drinkAlcoholicBeveragesYes: false,
  drinkAlcoholicBeveragesSince: '',
  drinkAlcoholicBeveragesAmount: '',
  anyMedicationOrDrugsInLastYearNo: false,
  anyMedicationOrDrugsInLastYearYes: false,
  anyMedicationOrDrugsInLastYearSince: '',
  examinedForHealthNo: false,
  examinedForHealthYes: false,
  examinedForHealthWhere: '',
  examinedForHealthResult: ''
});

async function submitForm() {
  try {
    await unemployedPrivateCoachingService.saveHealthQuestionnaire(documentId.value, formData.value);

    isSubmitting.value = false;
    emit('update:submitForm', !props.submitForm);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getDocumentData() {
  try {
    const { data } = await unemployedPrivateCoachingService.getHealthQuestionnaire(documentId.value);
    formData.value = { ...data.data};
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  await getDocumentData();
});
</script>

<style scoped>
.remove-form-group-bottom-margin {
  margin-bottom: 0 !important;
}
</style>

